import { render, staticRenderFns } from "./TeacherUsageModal.vue?vue&type=template&id=300211dd&scoped=true"
import script from "./TeacherUsageModal.vue?vue&type=script&lang=js"
export * from "./TeacherUsageModal.vue?vue&type=script&lang=js"
import style0 from "./TeacherUsageModal.vue?vue&type=style&index=0&id=300211dd&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300211dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300211dd')) {
      api.createRecord('300211dd', component.options)
    } else {
      api.reload('300211dd', component.options)
    }
    module.hot.accept("./TeacherUsageModal.vue?vue&type=template&id=300211dd&scoped=true", function () {
      api.rerender('300211dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PrincipalOverviewWork/components/TeacherUsageModal.vue"
export default component.exports